import { gql } from '@apollo/client';

export type TtPresortConfigItem = {
  id: number;
  fromCode: string;
  nextStopCode: string;
  carrierCode: string;
  ttBizType: string;
  presortCode: string;
  mappedSortingCode: string | null;
  labelCode: string | null;
  sortOrder: number | null;
  updatedBy?: string | null;
};

export type TtPresortConfigFilterInput = {
  fromCode?: string;
  carrierCode?: string;
  ttBizType?: string;
  presortCode?: string;
  isDeleted?: boolean;
};

export type TtPresortConfigPageResponse = {
  getTtPresortConfigsWithPagination: {
    content: TtPresortConfigItem[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
  };
};

export const GET_TT_PRESORT_CONFIGS_WITH_PAGINATION = gql`
  query GetTtPresortConfigsWithPagination(
    $filter: TtPresortConfigFilterInput
    $pageRequest: PageRequestTypeInput
  ) {
    getTtPresortConfigsWithPagination(filter: $filter, pageRequest: $pageRequest) {
      content {
        id
        fromCode
        nextStopCode
        carrierCode
        ttBizType
        presortCode
        mappedSortingCode
        labelCode
        sortOrder
        updatedBy
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;
